import store from '@/store';
import instance from './instance';

export default () => {
  instance.interceptors.request.use(
    (req) => {
      const token = store.getters['auth/getTokens']?.at;
      const that = req;

      if (token) that.headers.Authorization = `Bearer ${token}`;
      return that;
    },
    (err) => Promise.reject(err),
  );

  instance.interceptors.response.use(
    (res) => res,
    (err) => {
      switch (err?.response?.status) {
        case 401:
          console.log('權限過期');
          break;
        case 403:
          console.log('沒有權限');
          break;
        case 404:
          console.log('找不到資源');
          break;
        case 500:
          console.log('伺服器錯誤');
          break;
        default:
          console.log('網路有問題');
          break;
      }

      return Promise.reject(err);
    },
  );
};
